import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, MailCheck, Activity, Inbox } from "lucide-react";
import api from "../../lib/api";

// Jul-2026 (User-Wunsch) — gebündelter E-Mail-Bereich auf dem Admin-Dashboard:
// E-Mail-Freigaben, E-Mail-Center und E-Mail-Gesundheit an einem Ort.
export const AdminEmailPanel = () => {
    const [pending, setPending] = useState(null);
    const [unread, setUnread] = useState(null);

    useEffect(() => {
        api.get("/dealer/email-outbox", { params: { status: "pending", limit: 1 } })
            .then((r) => setPending(r.data.counts?.pending ?? 0)).catch(() => setPending(0));
        api.get("/email/accounts")
            .then((r) => setUnread((r.data.items || r.data || []).reduce((s, a) => s + (a.unread || 0), 0)))
            .catch(() => setUnread(0));
    }, []);

    const tiles = [
        { label: "E-Mail-Freigaben", desc: "KI-Antworten prüfen & versenden", icon: MailCheck, to: "/dealer/email-freigabe", badge: pending, badgeColor: "bg-amber-500 text-white", testId: "admin-email-approvals" },
        { label: "E-Mail-Center", desc: "Postfächer, Posteingang, Regeln", icon: Inbox, to: "/dealer/email", badge: unread, badgeColor: "bg-[#FFCC00] text-[#111827]", testId: "admin-email-center" },
        { label: "E-Mail-Gesundheit", desc: "Zustellung & Bounce-Überwachung", icon: Activity, to: "/admin/email-health", badge: null, testId: "admin-email-health" },
    ];

    return (
        <div className="mb-8" data-testid="admin-email-panel">
            <h2 className="font-display font-black text-lg mb-3 flex items-center gap-2">
                <Mail className="w-5 h-5 text-[#FFCC00]" /> E-Mail
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                {tiles.map((t) => (
                    <Link key={t.to} to={t.to} className="group bg-white border border-gray-200 rounded-sm p-4 hover:border-[#111827] transition-colors flex items-start gap-3" data-testid={t.testId}>
                        <t.icon className="w-5 h-5 text-gray-400 group-hover:text-[#111827] shrink-0 mt-0.5" />
                        <div className="min-w-0 flex-1">
                            <div className="font-bold text-sm flex items-center gap-2">
                                {t.label}
                                {t.badge > 0 && <span className={`text-[10px] font-black rounded-full px-1.5 py-0.5 ${t.badgeColor}`}>{t.badge}</span>}
                            </div>
                            <div className="text-xs text-gray-500 mt-0.5">{t.desc}</div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};
